import axios, { type AxiosInstance } from "axios";

import type { IRepositories } from "@/types/src/harpio-expert-frontend/repositories";

export class RepositoryHttp {
  private readonly http: AxiosInstance;

  constructor(
    private readonly url: string,
    authToken?: string,
  ) {
    this.http = axios.create({
      adapter: "fetch",
      headers: {
        "Content-Type": "application/json",
      },
      baseURL: url,
      fetchOptions: { cache: "force-cache" },
    });
    this.http.interceptors.request.use(
      (config) => {
        config.headers.Authorization = `Bearer ${authToken ?? "no-auth"}`;
        return config;
      },
      (error) => {
        console.log(error);
        throw error;
      },
    );
  }

  public findAll = async <Output>(endpoint: string) => {
    return await this.http.get<Output>(endpoint);
  };

  public findByFilter: IRepositories.Http.FindByFilter = async (
    url,
    filter,
  ) => {
    const result = await this.http.post(url, filter);
    return result;
  };

  public findOne = async <Output>(endpoint: string) => {
    return await this.http.get<Output>(endpoint);
  };

  public findById = async <Output>(endpoint: string, id: string) => {
    return await this.http.get<Output>(`${endpoint}/${id}`);
  };

  public create = async <Input, Output>(endpoint: string, data: Input) => {
    return await this.http.post<Output>(endpoint, data);
  };

  public update = async <Input, Output>(endpoint: string, data: Input) => {
    return await this.http.patch<Output>(endpoint, data);
  };
}
